import { SendMailStep } from "@complex/SendMailModal/stepper";
import { Button } from "@mui/material";
import type { Dispatch, SetStateAction } from "react";

interface ISendMailModalMailContentActionsProps {
  setStep: Dispatch<SetStateAction<SendMailStep>>;
  onClose: () => void;
  onSubmit: () => void;
  loading: boolean;
  submitDisabled: boolean;
}

export const SendMailModalMailContentActions = ({
  setStep,
  onClose,
  onSubmit,
  loading,
  submitDisabled,
}: ISendMailModalMailContentActionsProps) => {
  return (
    <>
      <Button onClick={onClose} color="primary" variant="outlined" aria-labelledby="Annuler">
        Annuler
      </Button>
      <Button
        onClick={() => setStep(SendMailStep.RECIPIENTS)}
        color="primary"
        variant="outlined"
        aria-labelledby="Précédent"
      >
        Précédent
      </Button>
      <Button onClick={onSubmit} variant="contained" disabled={submitDisabled} loading={loading}>
        Générer et envoyer
      </Button>
    </>
  );
};
